import { ID } from 'common/entities/IEntity';
import { Entity, Field } from 'typegraph';

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: ID;

	@Field()
	public subTitle: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public shortDescription: string;

	@Field()
	public iconURL: string;
}



// WEBPACK FOOTER //
// ./src/panels/recommended/entities/Product.ts